import React, { useEffect, useState } from "react";
import { Card, Typography, Descriptions, Spin } from "antd";
import { useParams } from "react-router-dom";
import axios from "axios";

const { Title, Paragraph } = Typography;

const ContactDetails = () => {
  const { id } = useParams();
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContact();
  }, [id]);

  const fetchContact = async () => {
    try {
      const response = await axios.get(`http://93.127.203.113:5005/contact/${id}`);
      setContact(response.data);
    } catch (error) {
      console.error("Error fetching contact request:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "40px", display: "flex", justifyContent: "center" }}>
      {loading ? (
        <Spin size="large" />
      ) : (
        <Card
          style={{
            width: "80%",
            maxWidth: "700px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Title level={3} style={{ color: "#0c8c49", marginBottom: "10px" }}>
            {contact.fullName}
          </Title>
          <Paragraph type="secondary" style={{ fontSize: "16px", marginBottom: "15px" }}>
            <strong>Email:</strong> {contact.email}
          </Paragraph>
          <Card
            style={{
              backgroundColor: "#f9f9f9",
              padding: "15px",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
            }}
          >
            <Paragraph
              style={{
                fontSize: "16px",
                fontStyle: "italic",
                color: "#555",
                lineHeight: "1.5",
              }}
            >
              "{contact.message}"
            </Paragraph>
          </Card>
        </Card>
      )}
    </div>
  );
};

export default ContactDetails;
